import { Component, EventEmitter, Input, Output } from '@angular/core';

import { getSocialIconClass } from 'app/social/get-social-icon-class';
import { ParseSocialService } from 'app/social/parse-social.service';
import { AppliedToplineItem, FieldStatus  } from 'generated/graphql';

@Component({
  selector: 'app-topline-social',
  templateUrl: './topline-social.component.html',
  // styleUrls: ['./topline-address.component.scss']
})
export class ToplineSocialComponent  {
  @Input() topline: Partial<AppliedToplineItem> | any;

  @Input() targetId: string;
  @Input() targetType: 'Entity' | 'EntityConnection';

  /** Will be used for top topline */
  @Input() truncate: boolean;
  @Output() addClick = new EventEmitter<any>();

  getSocialIconClass = getSocialIconClass;

  constructor(
    private _parseSocialSvc: ParseSocialService,
  ) { }


  onAddClicked() {
    const eventData = {
      targetType: this.targetType,
      targetId: this.targetId,
      topline: this.topline,
    };
    this.addClick.emit(eventData);
  }

  getSocialURL(network: string, profile: string): string {
    const parsedResult = this._parseSocialSvc.parseSocial(network, profile);
    try {
      if(new URL(parsedResult.sanitized)) {
        return parsedResult.sanitized;
      }
    } catch (err) {
      return null;
    }
    // if(!network || !profile)  {
    //   return;
    // }
    // const parsedResult = this._parseSocialSvc.parseSocial(network, profile);
    // return parsedResult.sanitized;
  }

  isBad() {
    return this.topline?.appliedToplineValue?.status === FieldStatus.Bad;
  }
}
